import DefineFormulation from "./DefineFormulation";
import FormulationList from "./FormulationList";
export default function Formulation({
  primaryServiceList,
  attributeProductList,
  attributeListReactSelect,
  addFormulation,
  changeFormulationData,
  data,
  formulationList,
  setFormulationList,
  formulationListCount,
  setFormulationListCount,
  showFormulationList,
  deactiveFormulation,
  attributeBaseOnProduct,
  setAttributeBaseOnProduct,
}) {
  return (
    <div className="d-flex flex-wrap">
      <div className="col-12 col-md-6 px-2 mx-auto mt-2">
        <h5 className="mb-1" style={{ fontSize: 13, fontWeight: "bold" }}>
          تعریف فرموله
        </h5>
        <DefineFormulation
          primaryServiceList={primaryServiceList}
          attributeProductList={attributeProductList}
          attributeListReactSelect={attributeListReactSelect}
          addFormulation={addFormulation}
          changeFormulationData={changeFormulationData}
          data={data}
          formulationList={formulationList}
          setFormulationList={setFormulationList}
          formulationListCount={formulationListCount}
          setFormulationListCount={setFormulationListCount}
          attributeBaseOnProduct={attributeBaseOnProduct}
          setAttributeBaseOnProduct={setAttributeBaseOnProduct}
        />
      </div>
      <div className="col-12 col-md-6 px-2 mx-auto mt-2">
        <h5 className="mb-1" style={{ fontSize: 13, fontWeight: "bold" }}>
          لیست فرموله
        </h5>
        <FormulationList
          data={showFormulationList}
          deactiveFormulation={deactiveFormulation}
        />
      </div>
    </div>
  );
}
